import React from 'react';
import '../styles/testimonials.css';
import { useScrollAnimation } from '../utils/useScrollAnimation';

function Testimonials() {
  const gridRef = useScrollAnimation();
  const testimonials = [
    {
      name: "Shreyashi Dhar Sarma",
      text: "The way they took the videos and photographs from me and my husband is like truly incredible, the team members just make them so comfortable that we got our best results of our big day, I'll recommend Wedding stories for the best budget friendly photography as well as cinematography. They are very good behaving human beings not only that they captured our best moments without any compromise.Thank you wedding stories for Making our day memorable for ever .",
      rating: 5
    },
    {
      name: "Jinia Ghosh",
      text: "It was my pleasure working with your team. Photos and videos are really nice. Thank you wedding story for make my day special 😍 …",
      rating: 5
    },
    {
      name: "Akash Barman",
      text: "Each & every pictures are truly beautiful...... you and your team did just awesome job.... Thank you so  much for capture best moments of our life...... tanks a ton for creat our wedding day a lot more special. The best part is 1:- Wedding Stories Team behaviour create bond like a friendship 🫶 2:- Best of the best part is Fast Photos and Album Handover 😇",
      rating: 5
    },
    {
      name: "Sonakshi Jha",
      text: "Booked Wedding Stories for my wedding. I must say that received some very good quality and beautifully captured photos and videos. Totally loved the wedding album. Overall satisfied with the service and a great experience. And yes, very well behaved and friendly team! Highly recommended!",
      rating: 5
    },
    {
      name: "Swati Bhattacharjee",
      text: "Booked wedding stories for our both side wedding coverage and pre wedding. It was an amazing experience from day 1. The products were delivered as promised. The album quality, the pictures of each and every occasion and the videos were excellent and most importantly the behaviour of the team was very cordial and comfortable. Definitely recommended to everyone and looking forward to booking them for any upcoming occasion!",
      rating: 5
    },
    {
      name: "Sourav De",
      text: "We are beyond thrilled with the exceptional service provided by Wedding Stories for our Wedding day and Reception ceremony. The overall PROFESSIONALISM, CREATIVITY, QUICK RESPONSE and ATTENTION TO DETAILS were outstanding which seamlessly captured every cherished moment and emotion, delivering TEASER , PHOTOS, ALBUMS,  and VIDEO that truly tell the story of our celebration. We couldn't be happier with the beautiful memories the team have created for us. Thank you for exceeding our expectations and leaving with us a priceless legacy.",
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return (
      <div className="stars">
        {[...Array(5)].map((_, i) => (
          <span key={i} className={i < rating ? 'star filled' : 'star'}>★</span>
        ))}
      </div>
    );
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <p className="section-eyebrow">Voices</p>
        <h1 className="section-title">Words Of Love From Our Couples</h1>
        <div className="section-line" aria-hidden="true" />
        
        <div className="testimonials-grid scroll-animate-stagger" ref={gridRef}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className='testimonial-card'>
              <div className='testimonial-header'>
                <h3 className='testimonial-name'>{testimonial.name}</h3>
                {renderStars(testimonial.rating)}
              </div>
              <p className='testimonial-text'>{testimonial.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
